import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [selectedApp, setSelectedApp] = useState(null);
  const [videoCardKey, setVideoCardKey] = useState(0);
  const [isVideoCardVisible, setIsVideoCardVisible] = useState(false);
  const [searchInput, setSearchInput] = useState('');

  const getAppColor = (appName) => {
    const colors = {
      Instagram: '#E1306C',
      Facebook: '#4267B2',
      Tiktok: '#121212',
      Dailymotion: '#006EF5',
      'X-twitter': '#121212',
      IMDb: '#F6C700',
      Likee: '#FE2262',
      Bitchute: '#EF4138',
      Thread: '#121212',
      Veoh: '#059AD3',
      BuzzVideo: '#F8D000',
      ESPN: '#8D2F4E',
      imgur: '#89C623',
      LinkedIn: '#006EA8',
      Pinterest: '#E13138',
      Snapchat: '#D7D400',
      Flickr: '#0063DB',
      'All Video Downloader': '#e22a2d'
    };
    return colors[appName] || colors['All Video Downloader'];
  };

  const urlPatterns = {
    Instagram: /instagram\.com|instagr\.am/i,
    Facebook: /facebook\.com|fb\.watch/i,
    Tiktok: /tiktok\.com/i,
    Dailymotion: /dailymotion\.com|dai\.ly/i,
    'X-twitter': /twitter\.com|x\.com/i,
    IMDb: /imdb\.com/i,
    Likee: /likee\.com|l.likee\.video/i,
    Bitchute: /bitchute\.com/i,
    Thread: /threads\.net/i,
    Veoh: /veoh\.com/i,
    BuzzVideo: /buzzvideo\.com|dai\.ly/i,
    ESPN: /espn\.com|espn\.in/i,
    imgur: /imgur\.com/i,
    LinkedIn: /linkedin\.com/i,
    Pinterest: /pinterest\.com|pin\.it/i,
    Snapchat: /snapchat\.com/i,
    Flickr: /flickr\.com|flic\.kr/i,
    'All Video Downloader': /.*/
  };

  const validateUrl = (url) => {
    if (!selectedApp || selectedApp === 'All Video Downloader') {
      return { isValid: true, message: '' };
    }

    const pattern = urlPatterns[selectedApp];
    if (!pattern) {
      return { isValid: false, message: 'Unknown app selected' };
    }

    const isValid = pattern.test(url);
    return {
      isValid,
      message: isValid ? '' : `Please enter a valid ${selectedApp} URL`
    };
  };

  const handleAppSelect = (appName) => {
    setSelectedApp(appName === 'All Video Downloader' ? null : appName);
    setVideoCardKey(prev => prev + 1);
    setIsVideoCardVisible(false);
    setSearchInput('');
  };

  const currentColor = selectedApp ? getAppColor(selectedApp) : getAppColor('All Video Downloader');

  return (
    <AppContext.Provider value={{ 
      selectedApp, 
      handleAppSelect, 
      currentColor,
      validateUrl,
      videoCardKey,
      isVideoCardVisible,
      setIsVideoCardVisible,
      searchInput,
      setSearchInput
    }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);